"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProductDocumentTemplatesController = /** @class */ (function () {
    function ProductDocumentTemplatesController(DocumentTemplateModel, FlashService) {
        var _this = this;
        this.templates = [];
        this.selectedTemplate = null;
        this.firstPurchaseOnly = false;
        this.completeAtCheckout = false;
        this.DocumentTemplateModel = DocumentTemplateModel;
        this.FlashService = FlashService;
        DocumentTemplateModel.getTemplates({
            status: "active",
            per_page: 100,
        }).then(function (response) {
            _this.templates = response.data;
            if (_this.templates.length > 0) {
                _this.selectedTemplate = _this.templates[0];
            }
        });
    }
    ProductDocumentTemplatesController.prototype.add = function () {
        if (!this.selectedTemplate) {
            return;
        }
        var base = this.selectedTemplate;
        var alreadyExists = this.product.document_templates.some(function (template) { return template.id === base.id; });
        if (alreadyExists) {
            this.FlashService.setMessage({
                type: "warning",
                message: "This template is already attached to the product.",
            });
            return;
        }
        // Copy so the shared template list isn't mutated (session-types pattern)
        var attached = Object.assign({}, base, {
            first_purchase_only: this.firstPurchaseOnly,
            complete_at_checkout: this.completeAtCheckout,
        });
        this.product.document_templates.push(attached);
        this.firstPurchaseOnly = false;
        this.completeAtCheckout = false;
    };
    ProductDocumentTemplatesController.prototype.remove = function (index) {
        this.product.document_templates.splice(index, 1);
    };
    ProductDocumentTemplatesController.prototype.getStatusClass = function (status) {
        var classes = {
            draft: "label-warning",
            active: "label-success",
            archived: "label-default",
        };
        return classes[status] || "label-default";
    };
    return ProductDocumentTemplatesController;
}());
ProductDocumentTemplatesController.$inject = [
    "DocumentTemplateModel",
    "FlashService",
];
exports.default = ProductDocumentTemplatesController;
